/**
 * Ghi chú - Thiết lập CT âm dương
 */
export default {
  Negative: -1,
  Positive: 1,
};
